/**
 * Componente: Solicitud de reimpresión de una licencia ya impresa
 * (extravío, robo, error de impresión). A diferencia de
 * ReportarFalloImpresionModal, acá TODA categoría dispara el pedido de
 * autorización al admin — no hay reintento self-service, porque la
 * tarjeta ya se dio por completada (ver backend
 * /licencias/:id/solicitar-reimpresion). Mismo patrón visual y de
 * validación (detalle obligatorio solo para "otro").
 */

import React, { useState } from 'react';
import { IconCerrar, IconAdvertencia } from './icons';

const MOTIVOS_REIMPRESION = [
  { value: 'extravio_robo', label: 'Extravío o robo' },
  { value: 'error_impresion', label: 'Error de impresión' },
  { value: 'otro', label: 'Otro' },
];

const SolicitarReimpresionModal = ({ procesando, onConfirmar, onCancelar }) => {
  const [motivoCategoria, setMotivoCategoria] = useState('extravio_robo');
  const [motivoDetalle, setMotivoDetalle] = useState('');
  const [error, setError] = useState('');

  const cambiarMotivo = (valor) => {
    setMotivoCategoria(valor);
    setError('');
  };

  const confirmar = () => {
    if (motivoCategoria === 'otro' && !motivoDetalle.trim()) {
      setError('Contá brevemente qué pasó');
      return;
    }
    onConfirmar(motivoCategoria, motivoDetalle.trim());
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content confirmar-eliminar-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Solicitar reimpresión</h2>
          <button className="modal-close" onClick={onCancelar} disabled={procesando}><IconCerrar size={18} /></button>
        </div>

        <div className="modal-body">
          {error && (
            <div className="alert alert-error">
              <IconAdvertencia size={18} />
              <p>{error}</p>
            </div>
          )}

          <div className="form-field">
            <label>Motivo</label>
            <select
              className="padron-input"
              value={motivoCategoria}
              onChange={(e) => cambiarMotivo(e.target.value)}
              disabled={procesando}
            >
              {MOTIVOS_REIMPRESION.map((m) => (
                <option key={m.value} value={m.value}>{m.label}</option>
              ))}
            </select>
          </div>

          {motivoCategoria === 'otro' && (
            <div className="form-field">
              <label>Contanos qué pasó *</label>
              <textarea
                className="padron-input"
                value={motivoDetalle}
                onChange={(e) => setMotivoDetalle(e.target.value)}
                rows={3}
                disabled={procesando}
              />
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-cancelar" onClick={onCancelar} disabled={procesando}>
            Cancelar
          </button>
          <button type="button" className="btn-guardar" onClick={confirmar} disabled={procesando}>
            {procesando ? 'Enviando...' : 'Confirmar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SolicitarReimpresionModal;
